import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Button, Form, Grid, Image, Container, Card, Message} from 'semantic-ui-react';

import auth from "../../data/auth";
import Toast from "../../components/extras/Toast";
import resources from "../../data/resources";
import localDB from "../../data/localDB";
import LocalData from "../../data/LocalData";

const logo = require('../../img/logo_text1.svg');

class Login extends Component {

    constructor() {
        super();

        this.state = {
            email: '',
            password: '',
            user_error: false,
            password_error: false,
            active: false
        };

        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        localDB.cleanSession();
    }

    handleEmailChange(event) {
        this.setState({email: event.target.value.toLowerCase().trim()});
        if (event.target.value.trim() === '') {
            this.setState({user_error: true})
        } else {
            this.setState({user_error: false})
        }
    }

    handlePasswordChange(event) {
        this.setState({password: event.target.value});
        if (event.target.value.trim() === '') {
            this.setState({password_error: true})
        } else {
            this.setState({password_error: false})
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.state.email === "" || !resources.validators.isValidEmailAddress(this.state.email)) {
            this.setState({user_error: true})
        } else if (this.state.password === "") {
            this.setState({password_error: true})
        } else {
            this.setState({active: true});
            auth.login(this.state.email, this.state.password, (res) => {
                if (res) {
                    this.setState({email: '', password: ''});
                    LocalData.products();
                    LocalData.clients();
                    LocalData.providers();
                    this.props.history.push('/');
                } else {
                    this.setState({password: ''});
                    this.refs.toast.show({message: 'Usuario y/o contraseña incorrecta!', type: 'error'});
                }
                this.setState({active: false});
            });
        }
    }

    render() {
        return (
            <div style={{minHeight: 'calc(100vh)', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Toast ref='toast'/>
                <Helmet>
                    <title>Quipuu - Ingresar</title>
                    <meta name="description" content="Inicia sesión en el sitio web para disfrutar de todas las funciones y contenido. Aquí podrás encontrar todo lo que necesitas para iniciar tu sesión, desde la creación de tu cuenta hasta la gestión de tu perfil."></meta>
                </Helmet>
                <Grid>
                    <Grid.Row columns={2} centered>
                        <Grid.Column mobile={16} tablet={8} computer={7} largeScreen={6} widescreen={6}>
                            <Container>
                                <Image centered src={logo} alt="Quipuu" size='middle' style={{'width': '60%'}}/>
                                <Card fluid>
                                    <Card.Content>
                                        <Card.Header>Iniciar sesión</Card.Header>
                                    </Card.Content>
                                    <Card.Content>
                                        <Form onSubmit={this.handleSubmit}>
                                            <Form.Field>
                                                <Form.Input icon='mail' iconPosition='left'
                                                            type='email'
                                                            autoComplete="username"
                                                            placeholder='Correo Electrónico' value={this.state.email}
                                                            onChange={this.handleEmailChange} error={this.state.user_error}/>
                                            </Form.Field>
                                            <Form.Field>
                                                <Form.Input icon='lock' iconPosition='left' placeholder='Contraseña'
                                                            value={this.state.password} type="password"
                                                            onChange={this.handlePasswordChange}
                                                            autoComplete="current-password"
                                                            error={this.state.password_error}/>
                                            </Form.Field>
                                            <Form.Field>
                                                <Button fluid type="submit" primary disabled={this.state.active}
                                                        loading={this.state.active}>Ingresar</Button>
                                            </Form.Field>
                                            <p>
                                                <span className='link' onClick={()=>this.props.history.push('/reset')}> ¿Olvidaste tu contraseña?</span>
                                            </p>
                                        </Form>
                                    </Card.Content>
                                </Card>
                                <Message>
                                    <strong>
                                        ¿Tienes un negocio?<span className='link' onClick={()=>this.props.history.push('/register')}> crea una cuenta!</span>
                                    </strong>
                                </Message>
                            </Container>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/containers/main/Login.js